import * as React from 'react';
import { DisplayCodes, Permission, MeatballMenu, PromptConfirmationModal } from 'ui';
import styles from './compact-code-title-tile.scss';
import { TileProps } from 'ui/tile/tile';

export class CompactCodeTitleTile extends React.PureComponent<TileProps, void> {

  public static defaultProps: Partial<TileProps> = {
    enabledChildEntityOperations: { remove: false }
  };

  private handleDelete = (e?: any) => {
    e && e.preventDefault();
    this.props.onDeleteDocumentItem && this.props.onDeleteDocumentItem();
  };

  public render() {
    const {
      componentId,
      primaryKey,
      children,
      showPrimaryKey = true
    } = this.props;

    const { controlLabel, compactCodeTile, withMeatballMenu } = styles;
    const removableFieldStyles = this.shouldRenderContextMenu() ? withMeatballMenu : '';

    return (
      <div id={componentId} className={`className ${compactCodeTile} ${removableFieldStyles}`}>
        {showPrimaryKey && <DisplayCodes
          componentId={`${componentId}-code`}
          className={controlLabel}
          valueItems={[primaryKey]}
          displayIcon={'left'}
          options={undefined}
          onChange={undefined}
        />}
        {this.renderContextMenu()}
        {children}
      </div>
    );
  }

  private shouldRenderContextMenu = () => {
    const { enabledChildEntityOperations } = this.props;

    return enabledChildEntityOperations && Object.keys(enabledChildEntityOperations)
      .reduce((acc, key) => acc || enabledChildEntityOperations[key], false);
  };

  // TODO: Move this (and the copy in CodeTitleTile) to a shared enhancer.
  private renderContextMenu() {

    if  (!this.shouldRenderContextMenu()) {
      return undefined;
    }

    const { enabledChildEntityOperations, textDelete, textDeleteMessage, textContinue, textCancel } = this.props;
    const { tileDropdown } = styles;

    return (
      <Permission requireAny="remove" permissions={enabledChildEntityOperations}>
        <div className={tileDropdown}>
          <MeatballMenu>
              <Permission requireAll="remove" permissions={enabledChildEntityOperations} isListElement={true}>
                <PromptConfirmationModal
                  title={textDelete}
                  description={textDeleteMessage}
                  continueText={textContinue}
                  cancelText={textCancel}
                  onContinue={this.handleDelete}>
                  <button type="button" className="dropdown-item">{textDelete}</button>
                </PromptConfirmationModal>
              </Permission>
          </MeatballMenu>
        </div>
      </Permission>
    );
  }
}
